import React, { useState, useEffect, useCallback } from 'react';

// Thêm function getStatusBadgeStyle vào component
const getStatusBadgeStyle = (status) => {
    const statusColors = {
        'Đã gửi KH - Đang giao': { bg: '#fff3cd', color: '#856404', border: '#ffeaa7' },
        'KH đã nhận - hoàn tất đơn': { bg: '#d4edda', color: '#155724', border: '#00b894' },
        'Đã hủy': { bg: '#f8d7da', color: '#721c24', border: '#e17055' },
        'Đang xử lý (điều phối)': { bg: '#f4f4f4', color: '#495057', border: '#b2bec3' }
    };
    const defaultStyle = { bg: '#e3f2fd', color: '#1976d2', border: '#74b9ff' };
    return statusColors[status] || defaultStyle;
};

// Component StatusBadge
const StatusBadge = ({ status }) => {
    if (!status) return null;

    const badgeStyle = getStatusBadgeStyle(status);

    return (
        <span
            className="badge"
            style={{
                backgroundColor: badgeStyle.bg,
                color: badgeStyle.color,
                border: `1px solid ${badgeStyle.border}`,
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: '500'
            }}
        >
            {status}
        </span>
    );
};

export default StatusBadge;